import React from 'react';

import { money as moneyFormatter } from 'utils/format/money';
import Actions from './Actions';

const columns = [
  {
    name: 'Name',
    selector: 'attributes.name',
    sortable: true,
  },
  {
    name: 'Price',
    selector: (row) => moneyFormatter(row.attributes.price),
    sortable: true,
  },
  {
    name: 'Action',
    sortable: false,
    width: '100px',
    cell: (row) => <Actions row={row} />,
  },
];

export default columns;
